import React, { Component } from "react";
import propTypes from "prop-types";
import { connect } from "react-redux";
import { login } from "../../../actions/user";
import LoginForm from "../../forms/loginForm";
import { Title } from "../../ui/typography/typography";
import styles from "./loginPage.css";

class LoginPage extends Component {
	submit = data =>
		this.props.login(data).then(() => this.props.history.push("/"));

	render() {
		return (
			<div className={styles.container}>
				<Title className={styles.title}>Login to Wiki</Title>
				<LoginForm submit={this.submit} />
			</div>
		);
	}
}

LoginPage.propTypes = {
	history: propTypes.shape({
		push: propTypes.func.isRequired
	}).isRequired,
	login: propTypes.func.isRequired
};

export default connect(null, { login })(LoginPage);



// WEBPACK FOOTER //
// ./src/components/pages/loginPage/loginPage.js